module.exports = __webpack_public_path__ + "img/logo.167de383.svg";